import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "nav" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Wallet")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Auctions")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Create")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("About")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" | powered by griptape.js! 🛹 ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_scrt_balance = _resolveComponent("scrt-balance")!
  const _component_create_viewing_key = _resolveComponent("create-viewing-key")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _hoisted_3,
      _createVNode(_component_router_link, { to: "/wallet" }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _hoisted_5,
      _createVNode(_component_router_link, { to: "/auctions" }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }),
      _hoisted_7,
      _createVNode(_component_router_link, { to: "/create" }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }),
      _hoisted_9,
      _createVNode(_component_router_link, { to: "/about" }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      }),
      _hoisted_11
    ]),
    _createElementVNode("div", null, [
      _hoisted_12,
      _createVNode(_component_scrt_balance),
      _createVNode(_component_create_viewing_key)
    ]),
    _createVNode(_component_router_view)
  ], 64))
}